import AXIOS from './axiosClient'

class SearchFieldService {
  loadProductionFields() {
    return AXIOS.get('/getBaseSearchFields')
  }

  loadLicenceFields() {
    return AXIOS.get('/getLicenceSearchFields')
  }

  loadLookupData(searchField) {
    return AXIOS.get('/lookupValues/' + searchField);
    // return AXIOS.get('/getSearchFieldValueList?searchField='+searchField);
  }

  loadRightsDisplayText(selection) {
    return AXIOS.post('/getRightsDisplayText', selection);
  }

  loadTerritoryDisplayText(selection) {
    return AXIOS.post('/getTerritoryDisplayText', selection);
  }

  loadDisplayText(fieldName, selection) {
    return AXIOS.post('/getDisplayText?fieldName=' + fieldName, selection);
  }

}

export default new SearchFieldService();